import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nltobr'
})
export class NltobrPipe implements PipeTransform {
  transform(value: string, args: string[]): any {
    if (!value) {
      return value;
    }
    let breakTag = '<br>';
    return (value + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  }
}
